module.exports = __webpack_public_path__ + "static/img/normal page top img_desktop.5209d21d.jpg";